import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import Breathing from './Breathing/Breathing';
import Home from './Home/Home';
import reportWebVitals from './reportWebVitals';
import { Routes, Route, BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL}>

<Routes>
    <Route path="/breathing" element={<Breathing />} />
    <Route path="/" element={<Home />} />
</Routes>
</BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
